import { useState } from "react";
import { useHistory } from "react-router-dom";
import { offerMerchant } from "./offerPresentation";

const BADGE_SVG = (
  <svg viewBox="0 0 100 100" fill="none" aria-hidden="true">
    <circle cx="53" cy="43" r="25" stroke="#fff" strokeWidth="7" />
    <path d="M35 61 L20 77" stroke="#fff" strokeWidth="9" strokeLinecap="round" />
    <text
      x="53"
      y="55"
      textAnchor="middle"
      fontFamily="Poppins,Arial"
      fontWeight="700"
      fontSize="32"
      fill="#fff"
    >
      $
    </text>
  </svg>
);

const QUALITIES = [
  { key: "Excelente", cls: "q-excelente", label: "Exc" },
  { key: "Bom", cls: "q-bom", label: "Bom" },
  { key: "Esgotou", cls: "q-esgotou", label: "Esg" },
];

const SELOS = ["Neutro", "Excelente", "Bom", "Esgotou"];

function brl(n) {
  const value = Number(n);
  if (!value || value <= 0) return null;
  return "R$ " + value.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export default function OfertaCard({ product, onQuality, onDelete, onEdit, onLive, onDestaque, isAdmin, showLive, addedToLive = [] }) {
  const alreadyLive = addedToLive.includes(product.id);
  const history = useHistory();
  const [copied, setCopied] = useState(false);

  const selo = SELOS.includes(product.selo) ? product.selo : "Neutro";
  const esgotada = selo === "Esgotou";
  const price = brl(product.offer_price);

  const go = () => {
    // Mesmo esgotada, a oferta continua clicável (abre o link normalmente).
    if (product.link) window.open(product.link, "_blank", "noopener");
    else history.push(`/produto/${product.id}`);
  };

  const copyCoupon = (e) => {
    e.stopPropagation();
    if (navigator.clipboard) navigator.clipboard.writeText(product.cupom);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className={`oav-card ${esgotada ? "is-esgotada" : ""}`}>
      <div className="oav-card-link" onClick={go} role="button" tabIndex={0}>
        <div className="oav-img">
          {product.image_url ? (
            <img src={product.image_url} alt={product.name} loading="lazy" />
          ) : (
            <span className="ph">📦</span>
          )}
          {selo !== "Neutro" && !esgotada && (
            <span className={`oav-badge q-${selo.toLowerCase()}`} title={selo}>
              {BADGE_SVG}
            </span>
          )}
          {esgotada && <div className="oav-esgotada">Oferta Esgotada!</div>}
        </div>

        <div className="oav-titulo">{product.name}</div>
        <div className="oav-sub">
          {offerMerchant(product)}
        </div>

        <div className="oav-preco">
          {price || <span className="oav-no-price">Preço no link</span>}
        </div>

        {product.cupom ? (
          <span
            className={`oav-cupom-tag ${product.link_resgate ? "com-link" : ""}`}
            onClick={copyCoupon}
            title="Toque para copiar"
          >
            🏷️ {copied ? "Copiado!" : `Cupom: ${product.cupom}`}
          </span>
        ) : null}

        {product.link_resgate ? (
          <a
            className="oav-resgate-tag"
            href={product.link_resgate}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.stopPropagation();
              if (product.cupom && navigator.clipboard) {
                navigator.clipboard.writeText(product.cupom);
              }
            }}
            title="Copia o cupom e abre o site"
          >
            🎟️ Resgatar Cupom
          </a>
        ) : null}

      </div>

      {isAdmin && (
        <div className="oav-admin-row">
          <div className="oav-q-btns">
            {QUALITIES.map((q) => (
              <button
                key={q.key}
                type="button"
                className={`oav-q-btn ${q.cls} ${selo === q.key ? "is-active" : ""}`}
                title={q.key}
                onClick={(e) => {
                  e.stopPropagation();
                  onQuality(product.id, selo === q.key ? "Neutro" : q.key);
                }}
              >
                {q.label}
              </button>
            ))}
          </div>
          <div className="oav-admin-actions">
            {onDestaque && (product.board || "ao_vivo") === "ao_vivo" && (
              <button
                type="button"
                className={`oav-q-btn oav-fav ${product.destaque ? "is-on" : ""}`}
                title={product.destaque ? "Remover dos favoritos" : "Favoritar (aparece pra todos)"}
                onClick={(e) => {
                  e.stopPropagation();
                  onDestaque(product);
                }}
              >
                {product.destaque ? "♥" : "♡"}
              </button>
            )}
            {showLive &&
              (alreadyLive ? (
                <button
                  type="button"
                  className="oav-q-btn oav-q-live is-live"
                  title="Já está nas Ofertas Live"
                  disabled
                >
                  ✓ Live
                </button>
              ) : (
                <button
                  type="button"
                  className="oav-q-btn oav-q-live"
                  title="Adicionar às Ofertas Live"
                  onClick={(e) => {
                    e.stopPropagation();
                    onLive(product);
                  }}
                >
                  + Live
                </button>
              ))}
            <button
              type="button"
              className="oav-q-btn oav-edit"
              title="Editar Oferta"
              onClick={(e) => {
                e.stopPropagation();
                onEdit(product);
              }}
            >
              ✏️
            </button>
            <button
              type="button"
              className="oav-del"
              title="Excluir"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(product);
              }}
            >
              🗑
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

